import React from 'react';

import stepsStyle from './recipe-steps.module.css';

type Props = {
  current: number;
  length: number;
};

const RecipeSteps = ({ current, length }: Props) => {
  return (
    <ul className={stepsStyle.steps}>
      {[...Array(length)].map((_, index) => {
        const css = `${stepsStyle.step} ${current >= index ? stepsStyle.active : ''}`;
        return <li className={css} key={index}></li>;
      })}
    </ul>
  );
};

export default RecipeSteps;
